export default __webpack_public_path__ + "static/media/entryforminput.344f0894.png";